/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-unused-vars */
import * as React from 'react';
import type { SVGProps } from 'react';
const SingleSizeIllustrationFeedbackDefaultVeryHappy = (
  props: SVGProps<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 42 42"
    data-xds="SingleSizeIllustrationFeedbackDefaultVeryHappy"
    role="presentation"
    {...props}
  >
    <g clipPath="url(#clip0_10198_380)">
      <path
        fill="var(--xdlColorIllustrationOutlineSecondary)"
        d="M21 42c11.598 0 21-9.402 21-21S32.598 0 21 0 0 9.402 0 21s9.402 21 21 21"
      />
      <path
        fill="#1D2124"
        d="M15.16 11.5c2.21 0 4.14 1.28 5.42 3.22l-.83.55c-1.14-1.73-2.79-2.78-4.58-2.78s-3.43 1.04-4.58 2.78l-.83-.55c1.28-1.94 3.21-3.22 5.42-3.22zM27.16 11.5c2.21 0 4.14 1.28 5.42 3.22l-.83.55c-1.14-1.73-2.79-2.78-4.58-2.78s-3.43 1.04-4.58 2.78l-.83-.55c1.28-1.94 3.21-3.22 5.42-3.22zM21.17 23.74a5.98 5.98 0 0 1-5.97-5.97l1-.03c0 2.77 2.23 5 4.97 5s4.97-2.23 4.97-4.97l1-.03v.03a5.98 5.98 0 0 1-5.97 5.97"
      />
      <path
        fill="#1D2124"
        d="M41 21C41 9.954 32.046 1 21 1S1 9.954 1 21s8.954 20 20 20v1C9.402 42 0 32.598 0 21S9.402 0 21 0s21 9.402 21 21-9.402 21-21 21v-1c11.046 0 20-8.954 20-20"
      />
    </g>
    <defs>
      <clipPath id="clip0_10198_380">
        <path fill="#fff" d="M0 0h42v42H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SingleSizeIllustrationFeedbackDefaultVeryHappy;
